import React, { useState, useEffect } from "react";
import Modal from "./index";
import Button from "../button";
import GamesFull from "../../assets/images/game-full.gif";

interface JoinGameErrorModalProps {
  errorMsg: string;
  joinGame?: Function;
  createGame: Function;
  hideClose?: Boolean;
}

interface msgs {
  "no-games": string;
  "join-error": string;
}

const msgs: msgs = {
  "no-games":
    "There are no games currently available. Try creating a new game below.",
  "join-error":
    "Sorry! The game you were trying to join is already full. Join a new game or start your own below."
};

declare const window: any;

const JoinGameErrorModal = ({
  errorMsg,
  joinGame,
  createGame,
  hideClose
}: JoinGameErrorModalProps) => {
  const [modalOpen, setModalOpen] = useState(!!errorMsg);

  useEffect(() => {
    const img = new Image();
    img.src = GamesFull;
  }, []);
  function modalAction(action: Function) {
    setModalOpen(false);
    setTimeout(() => {
      createGame();
    }, 500);
  }

  useEffect(() => {
    if (!!errorMsg) {
      window.bindTracking({
        type: "dynamic-page",
        data: {
          pageviewevent: 1,
          screenName: "The Game's Full",
          screenSection: "The Game's Full",
          interactionName: "The Game's Full"
        }
      });
      setModalOpen(!!errorMsg);
    }
  }, [errorMsg]);

  const closeModal = () => {
    setModalOpen(false);
    window.location.reload();
  };

  return (
    <Modal
      hideClose={hideClose}
      closeModal={closeModal}
      title="Bah Humbug!"
      isOpen={modalOpen}
    >
      <div
        className="image-bar"
        style={{
          backgroundImage: `url(${GamesFull})`
        }}
      ></div>
      <div className="copy">
        There are no games available, or something went terribly, terribly wrong... Create a new game
        below.
      </div>
      <div className="buttons flex items-center justify-center flex-col">
        <Button color="green" onClick={() => modalAction(createGame)}>
          Create a Game
        </Button>
      </div>
    </Modal>
  );
};

export default JoinGameErrorModal;
